module.exports = __webpack_public_path__ + "static/media/two-days.b76519a8.png";